import * as h2Api from '../../h2Api'
import * as earlyGameboard from '../earlyGameboard'

export const PROFILE_LOAD = 'EARLY_OCC_PROFILE_LOAD'
export const PROFILE_LOG = 'EARLY_OCC_PROFILE_LOG'
export const RATE_OCCUPATION = 'EARLY_OCC_RATE_OCCUPATION'
export const SAVE_RATE_OCCUPATION = 'EARLY_OCC_SAVE_RATE_OCCUPATION'
export const PROFILE_SELECT_LOADED = 'EARLY_PROFILE_SELECT_LOADED'
export const CACHE_INITIAL = 'EARLY_PROFILE_CACHE_SET_INITIAL'

export const saveRating = (occupation, ratingType) => (dispatch, getState) => {
  const loadedGameId = getState().early.gameboard.loadedGameId
  const name = getState().early.gameboard.userInfo

  return dispatch(
    h2Api.post(`/early/${loadedGameId}/rating`, {
      objectType: 'occupation',
      objectId: occupation.onetSoc,
      rating: ratingType
    })({ type: SAVE_RATE_OCCUPATION })
  )
}

export const rateOccupation = (occupation, ratingType) => dispatch => {
  console.log('RATING', occupation, ratingType)

  return Promise.resolve(
    dispatch({
      type: RATE_OCCUPATION,
      occupation,
      rating: ratingType
    })
  )
}

export const randomizeOccupation = () => (dispatch, getState) => {
  const pwCache = getState().early.occupationProfile.profileCache
  const keys = Object.keys(pwCache)
  const sortedKeys = [...keys].sort(() => {
    return 0.5 - Math.random()
  })

  //return dispatch(h2Api.get("/pathways/pathway/random")({type: PROFILE_LOAD}))
  return Promise.resolve(sortedKeys[0])
}

export const loadOccupation = occupationId => (dispatch, getState) => {
  const exists = () => {
    dispatch({ type: PROFILE_SELECT_LOADED, selectedProfile: occupationId })

    return dispatch(
      h2Api.post(`/occupations/profile/${occupationId}/log`)({ type: PROFILE_LOG })
    )
  }

  return exists().then(() => {
    dispatch({
      type: earlyGameboard.REGISTER_VIEW,
      activityKey: 'occupations',
      activityValue: {
        occupationId,
        earlyExploration: true
      }
    })
  })
}
